import { useContext } from "react";
import { CimodeEnabledContext } from "./CimodeEnabledContext";
export function useCimodeLocaleOverride(instance) {
    const cimodeEnabled = useContext(CimodeEnabledContext);
    return cimodeEnabled ? "cimode" : instance.language;
}
//# sourceMappingURL=useCimodeLocaleOverride.js.map